module.exports = __webpack_public_path__ + "static/media/14.71cf2730.jpg";